module.exports = __webpack_public_path__ + "static/img/mockup-alerts.fc86c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alerts/mockup-alerts.png
// module id = 786
// module chunks = 1